import "./index.css";
import React, { Fragment, createRef } from "react";
import { CurrencyOptions } from "../../../../Constants/retailer";
import TokensPercentage from "../../../../components/TokensPercentage";
import Checkbox from "../../../BespokeCRMTabs/components/Checkbox";
import EditAddressInput from "../EditAddressInput";
import {
  paymentMethodOptions,
  paymentTypeOptions,
  productTypeOptions,
  saleTypeOptions,
  splittableOptions,
  EYE_LINE_ADS_ID,
} from "../constants";
import RadioGroup from "../Popup/components/RadioGroup";
import UploadPanel from "../../../../components/UploadPanel";
import { getFilePath } from "../../../../Utils/utils";
import Firebase from "../../../../firebasehelper";
import { YOUTUBE_URL } from "../../../../Constants/types";
import SingleFileUpload from "../../../ProductPortfolio/components/SingleFileUpload";
import PaymentFrequencyInput from "../Popup/components/PaymentFrequencyInput";
import ProductPriceInput from "../Popup/components/ProductPriceInput";
import TokenPriceInput from "../Popup/components/TokenPriceInput";

class EditPackagePopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contents: ["", "", "", ""],
      caption: "",
      description: "",
      price: { amount: 4000, frequency: "per_item" },
      productType: productTypeOptions[0],
      paymentType: paymentTypeOptions[1],
      paymentMethod: paymentMethodOptions[0],
      saleType: saleTypeOptions[1],
      splittable: splittableOptions[0],
      isgroup: "no", // TODO: what is this for?
      threshold: 0, // TODO: what is this for?
      mediaToDelete: [],
      media: [],
      resetFormFields: false,
      isGeoLocated: true,
      address: null,
      shouldResetYoutubeInput: false,
      productLogoPreview: "",
      productLogoFile: null,
      logoToDelete: null,
    };
    this.modalRef = createRef();
    this.editPackagePopupRef = createRef();
    this.saveBtnRef = createRef();
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.onOutsideClick);
  }

  componentDidUpdate(prevProps) {
    const { initialValue, brandId } = this.props;
    const { resetFormFields, media } = this.state;

    if (
      (initialValue && initialValue !== prevProps.initialValue) ||
      resetFormFields
    ) {
      const { customNameByBrand, caption } = initialValue;

      if (resetFormFields) this.removeUnsavedFilesFromStorage(media, false);

      this.setState({
        ...initialValue,
        caption: customNameByBrand ? customNameByBrand[brandId] : caption,
        contents: this.getContents(initialValue.contents),
        isgroup: initialValue.isgroup === 1 ? "yes" : "no",
        media: initialValue.media || [],
        isGeoLocated: initialValue.address ? true : false,
        address: initialValue.address ? initialValue.address : null,
        resetFormFields: false,
        shouldResetYoutubeInput: true,
        productLogoPreview: initialValue.productLogo || "",
        productLogoFile: null,
      });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.onOutsideClick);
  }

  onOutsideClick = (e) => {
    const { initialValue } = this.props;

    const isOpen = this.editPackagePopupRef.current.classList.contains("show");
    if (isOpen && !this.modalRef.current.contains(e.target) && initialValue) {
      // using timeout here for better UX
      setTimeout(() => {
        this.undoEdits();
      }, 300);
    }
  };

  // TODO: Potential future work - Instead of uploading files on selection, display a preview
  // and only upload files on save
  removeUnsavedFilesFromStorage = async (files, deleteFromQueue = true) => {
    const newlyAddedMedia = deleteFromQueue
      ? files
      : files.filter((item) =>
          this.props.initialValue.media.every(
            (originalItem) => item.mediaUrl !== originalItem.mediaUrl
          )
        );

    if (newlyAddedMedia.length === 0) {
      this.setState({ mediaToDelete: [] });
      return;
    }

    const deletePromises = newlyAddedMedia.map(async (item) => {
      if (item && item.mediaType !== YOUTUBE_URL) {
        const path = getFilePath("packages", item.mediaUrl, item.mediaType);
        try {
          await Firebase.deleteFile(path);
        } catch (error) {
          console.error("Error deleting file:", error);
        }
      }
    });

    await Promise.all(deletePromises);

    // clear mediaToDelete after deletion
    this.setState({ mediaToDelete: [] });
  };

  undoEdits = () => this.setState({ resetFormFields: true });

  getContents = (contents) => {
    const parts = contents.split("\n");
    return parts.slice(0, parts.length - 1).map((content) => content.slice(1));
  };

  onChangeHandler = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  onChangeContent = (e) => {
    let { contents } = this.state;
    let id = e.target.id;
    contents[id] = e.target.value;
    this.setState({ contents });
  };
  onPaymentTypeChange = (paymentType) => {
    this.setState({ paymentType });
  };
  onSaleTypeChanged = (saleType) => {
    this.setState({ saleType });
  };
  onSplittableChanged = (splittable) => {
    this.setState({ splittable });
  };
  addPackage = () => {
    const { onEdit } = this.props;
    const { caption, description, contents, mediaToDelete } = this.state;

    if (mediaToDelete.length > 0)
      this.removeUnsavedFilesFromStorage(mediaToDelete, true);

    if (caption && description && contents) {
      onEdit(this.state);
      this.saveBtnRef.current.click();
    } else alert("Please fill in all fields");
  };

  onSelectAddress = (addressObj) => this.setState({ address: addressObj });

  onCheckboxClick = () =>
    this.setState({ isGeoLocated: !this.state.isGeoLocated });

  onPaymentMethodChange = (newPaymentMethod) => {
    this.setState({ paymentMethod: newPaymentMethod });
  };

  onProductTypeChange = (productType) => {
    const isPhysical = productType.value === "physical";

    this.setState({
      productType: productType,
      price: { amount: isPhysical ? 4000 : 100, frequency: "per_item" },
      splittable: isPhysical ? splittableOptions[1] : splittableOptions[0],
      isGeoLocated: isPhysical,
      paymentType: !isPhysical
        ? { id: "quickbuy", label: "Single buy", value: "quickbuy" }
        : this.state.paymentType,
    });
  };

  updateState = (stateObject) => this.setState(stateObject);

  onDeleteLogo = (logoPath) => {
    // queue the file for deletion until user clicks save
    this.setState({
      productLogoFile: null,
      productLogoPreview: "",
      logoToDelete: logoPath,
    });
  };

  onPriceChange = (key, value) => {
    const updatedValue = key === "amount" ? value * 100 : value;

    this.setState((prevState) => ({
      price: {
        ...prevState.price,
        [key]: updatedValue,
      },
    }));
  };

  render() {
    const { territory, isEditingSuperPackageFromBrand, hex, white, brandId } =
      this.props;
    const {
      caption,
      description,
      productType,
      paymentType,
      price,
      saleType,
      splittable,
      contents,
      media,
      isGeoLocated,
      address,
      paymentMethod,
      shouldResetYoutubeInput,
      mediaToDelete,
      productLogoPreview,
    } = this.state;

    return (
      <div
        className="modal fade"
        id="edit_package_popup"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
        ref={this.editPackagePopupRef}
      >
        <div className="modal-dialog" style={{ maxWidth: 700 }} role="document">
          <div className="modal-content" ref={this.modalRef}>
            <div className="modal-header">
              <h5 className="modal-title">Update Product</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={this.undoEdits}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            {isEditingSuperPackageFromBrand ? (
              <div className="modal-body edit-package-modal-container">
                <label className="edit-package-modal__label">Name</label>
                <input
                  type="text"
                  className="form-control form-control-lg form-control-alt"
                  name="caption"
                  onChange={this.onChangeHandler}
                  placeholder="Type product name"
                  value={caption}
                />
              </div>
            ) : (
              <div className="modal-body edit-package-modal-container">
                <label className="edit-package-modal__label">Name</label>
                <input
                  type="text"
                  className="form-control form-control-lg form-control-alt"
                  name="caption"
                  onChange={this.onChangeHandler}
                  placeholder="Type product name"
                  value={caption}
                />
                {process.env.REACT_APP_USER === "admin" && (
                  <RadioGroup
                    title="Is the product physical or digital?"
                    selectedOption={productType}
                    options={productTypeOptions}
                    hex={hex}
                    onClick={this.onProductTypeChange}
                  />
                )}
                <RadioGroup
                  title="How will the product be received?"
                  selectedOption={paymentType}
                  options={paymentTypeOptions}
                  hex={hex}
                  onClick={this.onPaymentTypeChange}
                  disabled={productType.value === "digital"}
                />

                <h3
                  className={`popup__question ${
                    productType.value === "digital" ? "popup--disabled" : ""
                  }`}
                >
                  Is the product redeemable in a location?
                </h3>
                <Checkbox
                  label="Geo-located"
                  checked={isGeoLocated}
                  id="geo-located-product-edit"
                  hex={hex}
                  white={white}
                  onChange={this.onCheckboxClick}
                  classNames={`checkbox--no-margin-top popup__checkbox ${
                    productType.value === "digital" ? "popup--disabled" : ""
                  }`}
                />
                {isGeoLocated && (
                  <EditAddressInput
                    productAddress={address}
                    onSelectNewAddress={this.onSelectAddress}
                    white={white}
                    hex={hex}
                  />
                )}

                {productType.value === "digital" ? (
                  <TokenPriceInput
                    amount={price.amount}
                    territory={territory}
                    onChange={(e) =>
                      this.onPriceChange("amount", e.target.value)
                    }
                  />
                ) : (
                  <div className="price__container">
                    <ProductPriceInput
                      amount={price.amount}
                      territory={territory}
                      onChange={(e) =>
                        this.onPriceChange("amount", e.target.value)
                      }
                    />
                    <PaymentFrequencyInput
                      onPaymentFrequencyChange={(option) =>
                        this.onPriceChange("frequency", option.value)
                      }
                      white={white}
                      hex={hex}
                      value={price.frequency}
                    />
                  </div>
                )}

                <SingleFileUpload
                  label="Product logo"
                  logoPreview={productLogoPreview}
                  setLogoPreview={(imagePath) =>
                    this.setState({ productLogoPreview: imagePath })
                  }
                  hex={hex}
                  white={white}
                  updateState={(file) =>
                    this.setState({ productLogoFile: file })
                  }
                  onDelete={this.onDeleteLogo}
                />

                <label className="edit-package-modal__label">
                  Product Introduction
                </label>
                <textarea
                  className="form-control form-control-lg form-control-alt"
                  name="description"
                  value={description}
                  placeholder="Keep it short and snappy."
                  onChange={this.onChangeHandler}
                />
                <label className="edit-package-modal__label">
                  Product content
                </label>
                <UploadPanel
                  media={media}
                  updateState={this.updateState}
                  brandId={brandId}
                  hex={hex}
                  white={white}
                  shouldResetYoutubeInput={shouldResetYoutubeInput}
                  mediaToDelete={mediaToDelete}
                  isEditModal={true}
                  uploadDirectory="packages"
                />
                <label className="edit-package-modal__label">
                  Product features
                </label>
                {contents.slice(0, 4).map((item, index) => {
                  return (
                    <input
                      type="text"
                      className="form-control form-control-lg form-control-alt content-input"
                      id={index}
                      onChange={this.onChangeContent}
                      value={item}
                      key={index}
                    />
                  );
                })}
                <RadioGroup
                  title="Is the product available to purchase?"
                  selectedOption={saleType}
                  options={saleTypeOptions}
                  hex={hex}
                  onClick={this.onSaleTypeChanged}
                />
                {brandId !== EYE_LINE_ADS_ID && (
                  <Fragment>
                    <RadioGroup
                      title="Can the product be split between a group?"
                      selectedOption={splittable}
                      options={splittableOptions}
                      hex={hex}
                      onClick={this.onSplittableChanged}
                      disabled={productType.value === "digital"}
                    />
                    <RadioGroup
                      title="How is this product redeemable?"
                      selectedOption={paymentMethod}
                      options={paymentMethodOptions}
                      hex={hex}
                      onClick={this.onPaymentMethodChange}
                    />
                    <div
                      className={`threshold-container ${
                        paymentType.value === "subscription" ||
                        paymentMethod.value === "cash"
                          ? "popup--disabled"
                          : ""
                      }`}
                    >
                      <label>Tokens redeemed</label>
                      <TokensPercentage currency="£" />
                    </div>
                  </Fragment>
                )}
              </div>
            )}
            <div
              className="modal-footer"
              style={{ justifyContent: "space-between" }}
            >
              <button
                type="button"
                className={`btn btn-delete ${
                  isEditingSuperPackageFromBrand ? "btn--hide" : ""
                }`}
                data-dismiss="modal"
                data-toggle="modal"
                data-target="#remove_package"
              >
                Delete
              </button>
              <div className="modal-footer__container">
                <button
                  type="button"
                  className="btn btn-brand-hex btn-white"
                  style={{
                    "--hover-text-color": white ? "white" : "black",
                    "--hover-color": hex,
                    backgroundColor: "white",
                    color: "black",
                  }}
                  data-dismiss="modal"
                  onClick={this.undoEdits}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-green"
                  onClick={this.addPackage}
                >
                  Save
                </button>
                <button
                  type="button"
                  style={{ display: "none" }}
                  data-dismiss="modal"
                  ref={this.saveBtnRef}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default EditPackagePopup;



// WEBPACK FOOTER //
// ./src/screens/super_products/components/EditPackage/index.js